import React from 'react';
import styles from './ActivityLogFilters.module.css';

const ACTION_OPTIONS = [
  { value: '', label: 'All Actions' },
  { value: 'LOGIN', label: 'Login' },
  { value: 'RECEIPT_CREATED', label: 'Receipt Created' },
  { value: 'OFFERING_CREATED', label: 'Offering Created' },
  { value: 'MEMBER_ADDED', label: 'Member Added' },
  { value: 'PAYMENT_CREATED', label: 'Payment Created' },
];

const ActivityLogFilters = ({ filters, onChange, isSuperAdmin, derasars = [] }) => {
  const handle = (key) => (e) => onChange({ ...filters, [key]: e.target.value, _page: 1 });

  return (
    <div className={styles.bar}>
      <select
        value={filters.action || ''}
        onChange={handle('action')}
        className={styles.select}
      >
        {ACTION_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      <input
        type="date"
        value={filters.from || ''}
        onChange={handle('from')}
        className={styles.input}
        placeholder="From"
      />
      <input
        type="date"
        value={filters.to || ''}
        onChange={handle('to')}
        className={styles.input}
        placeholder="To"
      />

      {isSuperAdmin && (
        <select
          value={filters.derasarId || ''}
          onChange={handle('derasarId')}
          className={styles.select}
        >
          <option value="">All Derasars</option>
          {derasars.map((d) => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>
      )}
    </div>
  );
};

export default ActivityLogFilters;
